import { BaseProduct, ProductBuilderMachineContext } from '../types';
import { productHasColour } from './colour';

type GetBladeSize = (context: ProductBuilderMachineContext) => string[];
type ProductHasBladeSizeOption = (product: BaseProduct) => boolean;
type GetVariantOptionKeyForBladeSize = (
  product: BaseProduct,
) => BladeSizeKey | null;

type BladeSizeKey = 'option1' | 'option2' | 'option3';
type ProductHasVariantWithBladeSize = (
  bladeSize: string,
) => (product: BaseProduct) => boolean;

export const productHasBladeSizeOption: ProductHasBladeSizeOption = product =>
  product.options.includes('Blade Size');

export const getVariantOptionKeyForBladeSize: GetVariantOptionKeyForBladeSize = product => {
  const bladeSizeIndex = product.options.findIndex(
    option => option === 'Blade Size',
  );
  if (bladeSizeIndex === -1) return null;

  return `option${bladeSizeIndex + 1}` as BladeSizeKey;
};

export const getBladeSize: GetBladeSize = context => {
  const {
    products,
    custom: { colour },
  } = context;

  const productsWithOption = products.filter(product =>
    productHasColour(colour)(product),
  );

  const bladeSizeKey =
    productsWithOption.length > 0
      ? getVariantOptionKeyForBladeSize(productsWithOption[0])
      : null;
  if (bladeSizeKey === null) return [];

  return Array.from(
    new Set(
      productsWithOption
        .map(({ variants }) =>
          variants.map(variant => {
            return variant[bladeSizeKey] as string;
          }),
        )
        .flat(),
    ),
  );
};

export const productHasVariantWithBladeSize: ProductHasVariantWithBladeSize = bladeSize => product => {
  const optionKey = getVariantOptionKeyForBladeSize(product);
  if (optionKey === null) return false;

  return product.variants.some(variant => variant[optionKey] === bladeSize);
};
